module.exports = __webpack_public_path__ + "img/black_square_mobile.9fc2a61e.png";